// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */
.max-width-image {
    /* width: 1350px; */
    max-height: 400px; 
    height: 450px;
}

.max-height-image {
    max-height: 400px; 
}

.max-image {
    /* max-height: 100px;
    max-width: 100px;  */
    justify-content: center;
    align-items: center;
}
.map-container{
    justify-content: center;
    align-items: center;
    font-family: sans-serif;
    text-align: center;
}
path {
    pointer-events: all;
    opacity: 0.50;
}
path:hover {
    opacity:1;
    cursor: pointer;
}
.state-container {
    overflow: auto; 
    min-height: 800px;
    height: auto;
    display: flex; /* Use flexbox layout */
    flex-direction: column; /* Arrange children vertically */
    align-items: center;
}
.state-container>p{
    text-align: justify;
    text-align-last: center;
    max-width: 60%;
}

.state-container>ol{
    text-align: justify;
    text-align-last: center;
    max-width: 50%;
}
.state-dropdown {
    width: 200px; 
    padding: 8px;
    border: 1px solid #ccc; 
    border-radius: 4px; 
    font-size: 16px; 
}

.site-dropdown {
    width: 100%; 
    /* padding: 20%; */
    border: 100% solid #ccc; 
    border-radius: 4px; 
    font-size: 16px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
}
.site-dropdown-menu{
    width: 100%; 
    /* padding: 20%; */
    border: 100% solid #ccc; 
    border-radius: 4px; 
    font-size: 16px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    /* margin-right: -58%; */
    margin-left: 32%;
    margin-bottom: 1%;
}
.site-date-dropdown {
    /* width: 100%;  */
    /* border: 100% solid #ccc; 
    border-radius: 4px; 
    font-size: 16px;
    display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center; */
    margin-top: 2%; 
}

.site-day-dropdown {
    margin-top: 12%; 
}

/* .site-date-dropdown>p{
    text-align: left;
    text-align-last: center;
    max-width: 50%;
} */

.site-event-dropdown{
    /* display: flex;
    flex-flow: row;
    justify-content: center;
    align-items: center; */
    display: flex;
    justify-content: center;
    align-items: flex-start; 
    flex-wrap: wrap; 
}

p {
    text-align: center;
}

h1{
    text-align: center;
}

.date-container {
    justify-content: center;
    align-items: center;
    display: flex;
    flex-flow: column;
}

.day-container {
    justify-content: center;
    align-items: center;
    display: flex;
    flex-flow: column;
}

.date-dropdown {
    text-align: 'center' ;
    margin-top: -21%;
    margin-bottom: 22%;
    margin-right: 27%;
}

.day-dropdown {
    text-align: 'center' ;
    margin-top: -14%;
    margin-bottom: 22%;
    margin-right: 0%;
}

.heading-button-displays{
    display: flex;
    flex-flow: row;
    text-align: center;
    justify-content: center;
    gap: 120px;
}

.heading-button-day-displays{
    display: flex;
    flex-flow: row;
    text-align: center;
    justify-content: center;
    gap: 120px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;wBACoB;IACpB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,aAAa,EAAE,uBAAuB;IACtC,sBAAsB,EAAE,gCAAgC;IACxD,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB;;;;;;0BAMsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;GAIG;;AAEH;IACI;;;0BAGsB;IACtB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,UAAU;AACd","sourcesContent":["/* styles.css */\n.max-width-image {\n    /* width: 1350px; */\n    max-height: 400px; \n    height: 450px;\n}\n\n.max-height-image {\n    max-height: 400px; \n}\n\n.max-image {\n    /* max-height: 100px;\n    max-width: 100px;  */\n    justify-content: center;\n    align-items: center;\n}\n.map-container{\n    justify-content: center;\n    align-items: center;\n    font-family: sans-serif;\n    text-align: center;\n}\npath {\n    pointer-events: all;\n    opacity: 0.50;\n}\npath:hover {\n    opacity:1;\n    cursor: pointer;\n}\n.state-container {\n    overflow: auto; \n    min-height: 800px;\n    height: auto;\n    display: flex; /* Use flexbox layout */\n    flex-direction: column; /* Arrange children vertically */\n    align-items: center;\n}\n.state-container>p{\n    text-align: justify;\n    text-align-last: center;\n    max-width: 60%;\n}\n\n.state-container>ol{\n    text-align: justify;\n    text-align-last: center;\n    max-width: 50%;\n}\n.state-dropdown {\n    width: 200px; \n    padding: 8px;\n    border: 1px solid #ccc; \n    border-radius: 4px; \n    font-size: 16px; \n}\n\n.site-dropdown {\n    width: 100%; \n    /* padding: 20%; */\n    border: 100% solid #ccc; \n    border-radius: 4px; \n    font-size: 16px;\n    display: flex;\n    flex-flow: column;\n    justify-content: center;\n    align-items: center;\n}\n.site-dropdown-menu{\n    width: 100%; \n    /* padding: 20%; */\n    border: 100% solid #ccc; \n    border-radius: 4px; \n    font-size: 16px;\n    display: flex;\n    flex-flow: column;\n    justify-content: center;\n    align-items: center;\n    /* margin-right: -58%; */\n    margin-left: 32%;\n    margin-bottom: 1%;\n}\n.site-date-dropdown {\n    /* width: 100%;  */\n    /* border: 100% solid #ccc; \n    border-radius: 4px; \n    font-size: 16px;\n    display: flex;\n    flex-flow: row;\n    justify-content: center;\n    align-items: center; */\n    margin-top: 2%; \n}\n\n.site-day-dropdown {\n    margin-top: 12%; \n}\n\n/* .site-date-dropdown>p{\n    text-align: left;\n    text-align-last: center;\n    max-width: 50%;\n} */\n\n.site-event-dropdown{\n    /* display: flex;\n    flex-flow: row;\n    justify-content: center;\n    align-items: center; */\n    display: flex;\n    justify-content: center;\n    align-items: flex-start; \n    flex-wrap: wrap; \n}\n\np {\n    text-align: center;\n}\n\nh1{\n    text-align: center;\n}\n\n.date-container {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    flex-flow: column;\n}\n\n.day-container {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    flex-flow: column;\n}\n\n.date-dropdown {\n    text-align: 'center' ;\n    margin-top: -21%;\n    margin-bottom: 22%;\n    margin-right: 27%;\n}\n\n.day-dropdown {\n    text-align: 'center' ;\n    margin-top: -14%;\n    margin-bottom: 22%;\n    margin-right: 0%;\n}\n\n.heading-button-displays{\n    display: flex;\n    flex-flow: row;\n    text-align: center;\n    justify-content: center;\n    gap: 120px;\n}\n\n.heading-button-day-displays{\n    display: flex;\n    flex-flow: row;\n    text-align: center;\n    justify-content: center;\n    gap: 120px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
